import { Routes } from '@angular/router';
import { AdminLayoutComponent } from './layout/admin-layout/admin-layout.component';
import { authGuard } from './core/guards/auth.guard';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { PageUnauthorizedComponent } from './pages/page-unauthorized/page-unauthorized.component';
import { LoginComponent } from './features/login/login.component';
import { subMenuGuard } from './core/guards/sub-menu.guard';
import { withSubMenuId } from './core/utils/url-utils';

export const routes: Routes = [
  {
    path: '',
    component: AdminLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./features/home/home.component').then((c) => c.HomeComponent),
      },
      {
        path: 'building-annual-audit',
        loadChildren: () =>
          import(
            './features/land-management/building-annual-audit/building-annual-audit.routes'
          ).then((r) => r.BuildingAnnualAuditRoutes),
      },
      {
        path: 'asset-government-vehicle',

        children: withSubMenuId(23,[
          {
            path: ':assetId',
            loadComponent: () =>
              import(
                './features/assets-management-system/assets-government-vehicle/assets-government-vehicle.component'
              ).then((r) => r.AssetsGovernmentVehicleComponent),
          },
          {
            path: 'request-detail/:assetId',
            loadComponent: () =>
              import(
                './features/assets-management-system/assets-government-vehicle/request-detail/request-detail.component'
              ).then((c) => c.RequestDetailComponent),
          },
          {
            path: 'request-detail/edit-trip/:assetId',
            loadComponent: () =>
              import(
                './features/assets-management-system/assets-government-vehicle/edit-trip/edit-trip.component'
              ).then((c) => c.EditTripComponent),
          },
          {
            path: 'request-detail/activity/:assetId/:code/:gfmisCode',
            loadComponent: () =>
              import(
                './features/assets-management-system/assets-government-vehicle/activity/activity.component'
              ).then((c) => c.ActivityComponent),
          },
          {
            path: 'request-detail/activity/edit-trip-qrcode/:assetId/:code/:gfmisCode/:action',
            loadComponent: () =>
              import(
                './features/assets-management-system/assets-government-vehicle/edit-trip-qrcode/edit-trip-qrcode.component'
              ).then((c) => c.EditTripQrcodeComponent),
          },
        ]),
      },
      {
        path: 'asset-annual-count',

        children: withSubMenuId(24,[
          {
            path: ':assetId',
            loadComponent: () =>
              import(
                './features/assets-management-system/assets-annual-count/assets-annual-count.component'
              ).then((r) => r.AssetsAnnualCountComponent),
          },
          {
            path: 'detail/:assetId',
            loadComponent: () =>
              import('./features/assets-management-system/assets-annual-count/annual-detail/annual-detail.component').then(
                (c) => c.AnnualDetailComponent
              ),
          },
          {
            path: 'detail/update-status/:assetId/:code/:gfmisCode',
            loadComponent: () =>
              import('./features/assets-management-system/assets-annual-count/update-current-status/update-current-status.component').then(
                (c) => c.UpdateCurrentStatusComponent
              ),
          },
        ]),
      },
    ],
  },
  { path: 'login', component: LoginComponent },
  { path: 'unauthorized', component: PageUnauthorizedComponent },
  { path: 'page-not-found', component: PageNotFoundComponent },
  { path: '**', redirectTo: 'page-not-found', pathMatch: 'full' },
];
